import { combineReducers } from 'redux';

import byId from './byId/reducer';
import byQuery from './byQuery/reducer';

export default combineReducers({
  byId,
  byQuery
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/forumThreads/reducer.js
 **/